// One font size for a set of one-line titles (Seán, 2026-11-03; /live's session titles,
// LiveEvent.vue): the longest, on one line, fills its box exactly, and every other takes its
// size. Proportional: measured once at the stylesheet's size, the size scaled by the box's width
// over the longest title's (its scrollWidth: a title may be clipped to its box, max-width 100%,
// so it never widens the layout). Each title an inline-block, white-space: nowrap, in a box as
// wide as the others'; the caller applies the size (e.g. a CSS variable). Again whenever the
// source changes (the list, the window's width).
import {nextTick, onMounted, ref, watch} from "vue";

export function useFitLongestLine(rootRef, selector, source) {
  const size = ref("");
  async function fit() {
    if (!rootRef.value) return;
    await document.fonts.ready;
    size.value = ""; // measure at the stylesheet's size
    await nextTick();
    const titles = [...(rootRef.value?.querySelectorAll(selector) || [])];
    if (!titles.length) return;
    const ratios = titles.map((title) => title.parentElement.clientWidth / title.scrollWidth);
    const base = parseFloat(window.getComputedStyle(titles[0]).fontSize);
    size.value = `${Math.floor(Math.min(...ratios) * base * 0.995 * 10) / 10}px`; // a hair under
  }
  watch(source, fit, {flush: "post"});
  onMounted(fit);
  return size;
}
